module.exports = __webpack_public_path__ + "img/attack-dash-animations.b0305274.gif";